module.exports = __webpack_public_path__ + "static/media/CAD.875b93ef.svg";